import { ModalContent, ModalGrid, ModalHeader } from 'components/GlobalModal';
import queryKeys from 'config/queryKeys';
import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { setGlobalModalContent } from 'state/actions/globalUIActions';
import * as remoteApi from 'api/remote';
import { Objective, Plan } from 'types';

import KoalaTabs from 'koala/components/Tabs';
import KoalaIconButton from 'koala/components/IconButton';
import { CustomTermKey, translate } from 'utils/customTermUtils';

// Views
import EmbedContainer from './EmbedContainer';
import EmbedNotion from '../shared/EmbedNotion';
import EmbedConfluence from '../shared/EmbedConfluence';
import styled from 'styled-components';
import theme from 'theme';

import IconNotion from 'components/_assets/IconNotion.png';
import IconConfluence from 'components/_assets/IconConfluence.png';
import { useTranslation } from 'react-i18next';
import PublicAccess from './PublicAccess';
import ShareEmail from './ShareEmail';

const Container = styled.div`
  padding: ${theme.spacing.x2} 0;
`;

const TabLabel = styled.span`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.half};
  img {
    height: 1.4rem;
  }
`;

interface Props {
  objectiveId: string;
}

function MoveOutcome(props: Props) {
  const { objectiveId } = props;
  const dispatch = useDispatch();
  const [objective, setObjective] = useState<Objective>();
  const [tab, setTab] = useState('email');
  const currentWorkspace = useSelector((state: any) => state.session.currentWorkspace, shallowEqual);
  const { t } = useTranslation();
  const [plan, setPlan] = useState<Plan | undefined>(objective?.plan);
  // OUTCOME
  // Get the objective details
  const queryKey = [queryKeys.currentObjective, objectiveId];
  const staleTime = 0;
  useQuery(queryKey, remoteApi.fetchObjectiveDetails, {
    staleTime,
    onSuccess: (response: any) => {
      const objective: Objective = response.data;
      setObjective(objective);
      setPlan(objective.plan);
    },
  });

  const handleCancel = (e: any) => {
    e.preventDefault();
    dispatch(setGlobalModalContent(''));
  };

  if (!objective || !plan) {
    return null;
  }

  const embedUrl = `https://${process.env.REACT_APP_DOMAIN}/${currentWorkspace.slug}/embed/objective/${objective.nano_slug}`;

  return (
    <ModalGrid>
      <ModalHeader>
        <h2>{t('modals.share.title', { label: translate(currentWorkspace, CustomTermKey.OBJECTIVE, 1) })}</h2>
        <KoalaIconButton onClick={handleCancel} iconName="close" />
      </ModalHeader>
      <ModalContent>
        <KoalaTabs
          activeTab={tab}
          setActiveTab={setTab}
          tabs={[
            {
              label: t('modals.share.email'),
              key: 'email',
            },
            {
              label: t('modals.share.embed'),
              key: 'embed',
            },
            {
              label: (
                <TabLabel>
                  <img src={IconNotion} alt="Notion" /> Notion
                </TabLabel>
              ),
              key: 'notion',
            },
            {
              label: (
                <TabLabel>
                  <img src={IconConfluence} alt="Confluence" /> Confluence
                </TabLabel>
              ),
              key: 'confluence',
            },
          ]}
        />
        <Container>
          {tab === 'email' && <ShareEmail objective={objective} />}
          {tab === 'embed' && <EmbedContainer plan={plan} objective={objective} />}
          {tab === 'notion' && <EmbedNotion plan={plan} embedUrl={embedUrl} typeLabel="objective" />}
          {tab === 'confluence' && <EmbedConfluence plan={plan} embedUrl={embedUrl} />}
        </Container>
        <PublicAccess plan={plan} setPlan={setPlan} objective={objective} />
      </ModalContent>
    </ModalGrid>
  );
}

export default MoveOutcome;
